import vColors from 'vuetify/lib/util/colors'

export class MonitoringUtils {
  getStatusIcon (status) {
    const icons = {
      SUCCESS: 'mdi-check-circle-outline',
      ERROR: 'mdi-close-circle-outline',
      WARNING: 'mdi-alert-rhombus-outline',
      RUNNING: 'mdi-run-fast',
      ENDED: 'mdi-cancel'
    }
    return icons[status]
  }

  getStatusColor (status) {
    const $colors = {
      SUCCESS: vColors.cyan.base,
      ERROR: vColors.red.base,
      WARNING: vColors.orange.base,
      RUNNING: vColors.lightBlue.lighten1,
      ENDED: vColors.orange.darken2
    }
    return $colors[status]
  }

  getLevelColor (level) {
    const $colors = {
      INFO: vColors.lime.base,
      ERROR: vColors.red.base,
      WARN: vColors.orange.base,
      DEBUG: vColors.lightBlue.darken2
    }
    return $colors[level] || vColors.shades.black
  }

  formatObjectDate (obj, param = 'date') {
    if (obj[param]) {
      obj[param] = this.dateFormat(obj[param])
    }
    return obj
  }

  rawDateNow () {
    const now = new Date().toJSON()
    const dateRE = /(\d{4})-(\d{2})-(\d{2})/
    const match = now.match(dateRE)

    return match[1] + match[2] + match[3]
  }

  rawDate (date) {
    if (!date) return

    const parts = date.split('/')
    const year = parts[2]
    const month = parts[1]
    const day = parts[0]

    return `${year}${month}${day}`
  }

  dateFormat (date) {
    if (!date) return

    const year = date.substr(0, 4)
    const month = date.substr(4, 2)
    const day = date.substr(6, 2)
    return `${day}/${month}/${year}`
  }

  dateFormatHyphened (date) {
    if (!date) return

    const year = date.substr(0, 4)
    const month = date.substr(4, 2)
    const day = date.substr(6, 2)
    return `${year}-${month}-${day}`
  }

  dateNowFormated () {
    const minuteToMs = 60000
    const msTimezoneOffset = (new Date()).getTimezoneOffset() * minuteToMs
    const msDateNowAtLocalTimezone = Date.now() - msTimezoneOffset

    return (new Date(msDateNowAtLocalTimezone)).toISOString().substring(0, 10)
  }

  dateNowBeforeThisDayNumber (dayNumber = 0) {
    const minuteToMs = 60000
    const dayToMs = minuteToMs * 60 * 24
    const msTimezoneOffset = (new Date()).getTimezoneOffset() * minuteToMs
    const dayAtMs = dayNumber * dayToMs
    const msOfDateAtLocalTimezone = Date.now() - msTimezoneOffset - dayAtMs

    return (new Date(msOfDateAtLocalTimezone)).toISOString().substring(0, 10)
  }

  dateBeforeThisDayNumber (date, dayNumber = 0) {
    const minuteToMs = 60000
    const dayToMs = minuteToMs * 60 * 24
    const dayAtMs = dayNumber * dayToMs
    const _date = date.length < 10 ? this.dateFormatHyphened(date) : date
    const msOfDateAtLocalTimezone = new Date(_date).valueOf() - dayAtMs

    return (new Date(msOfDateAtLocalTimezone)).toISOString().substring(0, 10)
  }

  fillPagination (list, pageSize) {
    const deltaSize = list.length % pageSize
    const diferenceToFullPage = deltaSize === 0 ? 0 : pageSize - deltaSize
    const objectsToFill = Array(diferenceToFullPage).fill({})
    const cloneList = JSON.parse(JSON.stringify(list))

    return list.length !== 0 ? cloneList.concat(objectsToFill) : []
  }

  formatObjectExecutionTime (obj) {
    const notEmptyObject = (obj && obj.date && obj.monitoringID && obj.status)
    if (notEmptyObject) {
      obj.executionTime = obj.executionTime ? this.setTimeStamp(obj) : '--:--:--:-----'
    }
    return obj
  }

  setTimeStamp (obj) {
    return obj.status === 'RUNNING' ? 'RUNNING' : this.convertMSToTimeStamp(obj.executionTime)
  }

  convertMSToTimeStamp (value) {
    if (!value && value !== 0) return '--:--:--:-----'

    let ms = parseInt((value % 1000))
    let seconds = parseInt((value / 1000) % 60)
    let minutes = parseInt((value / (1000 * 60)) % 60)
    let hours = parseInt((value / (1000 * 60 * 60)) % 24)

    const formater = number => (number < 10) ? '0' + number : number

    ms = ms < 10 ? '00' + ms : (ms < 100 ? '0' + ms : ms)
    seconds = formater(seconds)
    minutes = formater(minutes)
    hours = formater(hours)

    return `${hours}:${minutes}:${seconds}:${ms}`
  }
}

export default new MonitoringUtils()
